import { render, staticRenderFns } from "./Tablist.vue?vue&type=template&id=28629362&scoped=true&"
import script from "./Tablist.vue?vue&type=script&lang=js&"
export * from "./Tablist.vue?vue&type=script&lang=js&"
import style0 from "./Tablist.vue?vue&type=style&index=0&id=28629362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28629362",
  null
  
)

export default component.exports